import { ErrorBoundary } from '../error/error-boundary';
import { Grid, LinearProgress, Paper } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  loading?: boolean;
};

export const TextContent = (props: Props) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        flexGrow: 1,
        borderBottom: '1px solid lightgrey',
        padding: 1,
      }}
    >
      {props.loading ? (
        <Grid size={{ xs: 12 }}>
          <LinearProgress></LinearProgress>
        </Grid>
      ) : (
        <Grid size={{ xs: 12 }}>
          <ErrorBoundary>
            <Paper sx={{ margin: 1, padding: 2 }}>{props.children}</Paper>
          </ErrorBoundary>
        </Grid>
      )}
    </Grid>
  );
};
